export default function UserAvatar({ username, avatar, size = "md", className = "" }) {
  const sizeMap = {
    sm:   "w-7 h-7 text-xs",
    md:   "w-9 h-9 text-sm",
    lg:   "w-12 h-12 text-base",
    xl:   "w-16 h-16 text-xl",
  };

  const initials = username
    ? username.split(" ").slice(0, 2).map((n) => n[0]).join("").toUpperCase()
    : "?";

  const sizeClass = sizeMap[size] || sizeMap.md;

  if (avatar) {
    return (
      <img
        src={avatar}
        alt={username || "avatar"}
        className={["rounded-full object-cover flex-none", sizeClass, className].join(" ")}
      />
    );
  }

  return (
    <div className={[
      "rounded-full bg-blue-500 text-white flex items-center justify-center font-semibold flex-none select-none",
      sizeClass, className,
    ].join(" ")}>
      {initials}
    </div>
  );
}
